export default __webpack_public_path__ + "static/lysicrates-torn-parper-nav-bar-V2-83e5452b506ae2897262b01daf4144e3.png";